export const dashboardFolderFormTheme = {
  drag: {
    bg: 'palette.tertiary.0',
    border: 'palette.surface.4',
    text: 'palette.tertiary.80',
    wrapper: {
      bg: 'palette.surface.4',
      borderRadius: '8px',
    },
  },
};
